<template>
  <div>
    <center>
       <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
      <h1>Premium</h1>
      <p>Follow Instructions Below</p>
      <hr>
      <img alt="logo" height="200px" src="../../assets/logo.png">
      <h1>Premium Features:</h1>
      <h3>$1.99/Month</h3>
      <h4>Cancel anytime through PayPal</h4>
      <ul class="list">
        <li>Email Incident Alerts</li>
        <li>Browser Notification Incident Alerts</li>
        <li>Incident Map</li>
      </ul>
      <div class="paypal" id="paypal-button-container"></div>
    </center>
  </div>
</template>
<script>
// import { set } from 'vue/types/umd';
import { loadScript } from "@paypal/paypal-js";
export default {
  data: () => ({
    incidents: [],
    emptyWatchlist: false,
    loading: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary",
    }
  }),
  name: 'App',

  components: {
  },

  async mounted(){ 

  },

  async created(){
    if (!localStorage.username){
      localStorage.removeItem('token');
      this.$router.push('login');
      return
    }
    console.log(localStorage.paid_user);
    if (localStorage.paid_user == 'true'){
      this.$router.push({path: 'watchlist'});
      return
    }

    this.loading = true;

    window.scrollTo(0,0);

   const paypalSettingsResponse = await fetch(`${localStorage.apiURL}/app/premium-info/paypal/settings`, {
      method: "GET",
      headers: {"deviceID": localStorage.token, "tokenID": localStorage.tokenID}
    });

    if (!paypalSettingsResponse.ok){
      this.loading = false;
      this.error(`Returned a ${paypalSettingsResponse.status}`);
      return;
    }
    const paypalInfoData = await paypalSettingsResponse.json();

    if (!paypalInfoData.success){
      this.loading = false;
      this.error(`an error occured: '${paypalInfoData.msg}'`);
      return;
    }
    
    let paypalClientId = paypalInfoData.paypalClientId;
    let paypalPlanId = paypalInfoData.paypalPlanId;
    
    let vm = this;

    let paypal;
    paypal = await loadScript({ "client-id": paypalClientId, "vault": true, "intent": "subscription" });

    paypal.Buttons({
      createSubscription: function(data, actions) {
        return actions.subscription.create({
          'plan_id': paypalPlanId
        });
      },
      onApprove: async function(data, actions) {
        console.log(actions);
        vm.sendPaymentValidationIdToServer(data.subscriptionID);
      }
    }).render('#paypal-button-container');

    this.loading = false;

  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async sendPaymentValidationIdToServer(transactionIdentifier){
      const paypalSettingsResponse = await fetch(`${localStorage.apiURL}/app/premium-info/paypal/payment`, {
          method: "POST",
          headers: {"Content-Type": "application/json", "deviceID": localStorage.token, "tokenID": localStorage.tokenID},
          body: JSON.stringify({
            transactionIdentifier: transactionIdentifier,
          })
        });

        if (!paypalSettingsResponse.ok){
          this.loading = false;
          this.error(`Returned a ${paypalSettingsResponse.status}`);
          return;
        }

        const paypalInfoData = await paypalSettingsResponse.json();

        if (!paypalInfoData.success){
          this.loading = false;
          this.error(`an error occured: '${paypalInfoData.msg}'`);
          return;
        }
      localStorage.paid_user = true;
      alert("You are now a premium user!");
      location.reload();
    }
  },
};
</script>

 
<style scoped>
.watchlistItems{
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
.watchlistItems:hover{
  background-color: rgb(209, 209, 209);
}
ul{
  text-align: center;
  list-style-position: inside;
}
.list{
  margin-top: 25px;
}

.paypal{
  margin-top: 50px;
}
</style>
